module.exports = __webpack_public_path__ + "static/media/web.426e24f5.png";